import React, { useEffect, useState } from "react";
import "./Cancel_order_details.css";
import Order_id_holder from "../order_details/order_id_holder/Order_id_holder";
import Receiver_info_holder from "../order_details/receiver_info_holder/Receiver_info_holder";
import Breadcrumb_comp from "../../common_components/breadcrumb-comp/Breadcrumb_comp";
import Payment_Summary from "../../cart/payment_summary/Payment_Summary";
import Common_Back_Header from "../../common_components/common_back_header/Common_Back_Header";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getCanceledOrder, getOrder } from "../../../features/order/orderSlice";
import { encodeId, formatDate } from "../../../utils/common";
import Cancel_order_details_table from "./Cancel_order_details_table/Cancel_order_details_table"
function Cancel_order_details() {
    const breadcrumbs = [
        { label: "Home", link: "/", isActive: false },
        { label: "MY ORDERS", link: "/account", isActive: false },
        { label: "CANCELLED ORDER DETAILS", link: "", isActive: true },
    ];

    const { id } = useParams()

    const [showCancelBtn, setShowCancelBtn] = useState()

    const dispatch = useDispatch();
    const order = useSelector((state) => state.order.order);
    useEffect(() => {
        const res = dispatch(getCanceledOrder(id));
        if (res.meta?.requestStatus === "fulfilled") {
            setShowCancelBtn(false);
        } else if (res.meta?.requestStatus === "rejected") {
            setShowCancelBtn(true)

        }
    }, [dispatch]);

   



    const data = {
        total_mrp: order?.total_mrp,
        total_tax: order?.total_tax,
        no_of_item: order?.no_of_item,
        total_selling_price: order?.total_selling_price,
        total_amount: order?.total_amount,
        payment_method: order?.Product_Order?.Payment_Method?.name,
        // count: order?.no_of_item,
        // total: order?.total_selling_price,
        // savings: order?.total_amount - order?.total_selling_price

    }
    return (
        <>
            <section className="Order_details">


                <div className="container">

                    <Common_Back_Header backNavigation="/my-orders" />

                    <div className="row">
                        <div className=" col-lg-8 col-md-7">
                            <Order_id_holder
                                headingText={`Order ID #${order?.Product_Order?.invoice_no}`}
                                date={formatDate(order?.createdAt)}
                                subText="Cancelled"
                                order={order}
                            />

                            <Cancel_order_details_table order={order} />
                        </div>
                        <div className="col-lg-4 col-md-5">
                            <Receiver_info_holder
                                showCancelBtn={showCancelBtn}
                                order={order}
                                user={order?.Product_Order?.User}
                                userAddress={order?.Product_Order?.User_Address}
                            />

                            <Payment_Summary data={order} />
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Cancel_order_details;
